// assets/subscription-default.js
(function () {
    // If you want ?subscribe=1 to auto-select
    const params = new URLSearchParams(location.search);
    if (params.get('subscribe') === '1') {
    // run the click code above
     function selectFirstPlan(root) {
    // Find the FIRST selling-plan radio inside this widget
    const first = root.querySelector('input[data-radio-type="selling_plan"]');
    if (first && !first.checked) {
      first.click(); // triggers the app's own handlers
      // Some themes listen for change explicitly:
      first.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function runOnce() {
    // Handle all widgets on the page (PDP, quick view, etc.)
    document.querySelectorAll('.shopify_subscriptions_app_block_label_children').forEach(selectFirstPlan);
  }

  // 1) Try immediately + a short retry loop (for late mounting)
  let tries = 0;
  const iv = setInterval(() => {
    tries++;
    runOnce();
    if (document.querySelector('input[data-radio-type="selling_plan"]') || tries > 60) {
      clearInterval(iv); // stop after first success or ~3s (60 * 50ms)
    }
  }, 50);

  // 2) MutationObserver as a backup (catches AJAX section loads)
  const mo = new MutationObserver((muts) => {
    for (const m of muts) {
      m.addedNodes?.forEach((n) => {
        if (!(n instanceof HTMLElement)) return;
        if (n.matches?.('.shopify_subscriptions_app_block_label_children')) {
          selectFirstPlan(n);
        } else {
          const list = n.querySelector?.('.shopify_subscriptions_app_block_label_children');
          if (list) selectFirstPlan(list);
        }
      });
    }
  });
  mo.observe(document.documentElement, { subtree: true, childList: true });
}
    }
 )();

